export default __webpack_public_path__ + "static/media/volvo.2b4b2a78.png";